
import {combineLatest as observableCombineLatest, Subscription } from 'rxjs';
import { Component, Input, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppState } from '../../../interfaces/app-state.cadastro.interface';
import { UtilitiesService } from '../../../services/utilities.service';

@Component({
    selector: 'tr-suitability-question-select-answer',
    templateUrl: './tr-suitability-question-select-answer.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class TrSuitabilityQuestionSelectAnswerComponent {

    @Input() public set code(value: string) {
        this._code = value;
        this.init(value);
    }
    @Input() public formCtrlName: FormControl = new FormControl();

    public form: FormGroup;
    public answerList = [];
    public question: any;
    private questionText: string;
    private answerGuid: string;
    private suitabiitySubscription: Subscription;
    // tslint:disable-next-line:variable-name
    private _code: string;

    constructor(
        private store: Store<AppState>,
        private utilsService: UtilitiesService,
        private ref: ChangeDetectorRef,
        private formBuilder: FormBuilder,
    ) {

        this.answerGuid = utilsService.guid();
        this.form = this.formBuilder.group({
            value: [null, Validators.required],
        });

        this.form.valueChanges.subscribe((payload) => {
            if (payload.value) {
                this.formCtrlName.patchValue({questionID: this.question.id, answerID: payload.value});
            } else {
                this.formCtrlName.patchValue(false);
            }
            this.formCtrlName.updateValueAndValidity();
        });
    }

    public init(code: string) {

        if (!code) return;

        if (this.suitabiitySubscription) {
            this.suitabiitySubscription.unsubscribe();
        }

        this.suitabiitySubscription = observableCombineLatest(
            this.store.select((s) => s.suitability.questions),
            this.store.select((s) => s.suitability.answers),
            this.store.select((s) => s.suitability.usersAnswers),
        )
        .subscribe( ([questions, answers, usersAnswers]) => {
            // Pergunta
            this.question = questions.find((e) => this._code === e.code);
            if (this.question && usersAnswers) {
                const relatedAnswer = usersAnswers.find((a) => a.questionID === this.question.id) || {};
                this.form.get('value')
                    .patchValue(relatedAnswer.answerID);
            }
            // Respostas possíveis
            if ( this.question && answers) {
                this.answerList = answers.filter((e) => e && e.questionID === this.question.id );
            }
        });
    }
}
